import { render, staticRenderFns } from "./ClientEventCard.vue?vue&type=template&id=fa00a596&scoped=true&"
import script from "./ClientEventCard.vue?vue&type=script&lang=js&"
export * from "./ClientEventCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientEventCard.vue?vue&type=style&index=0&id=fa00a596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa00a596",
  null
  
)

export default component.exports